import React from 'react';
import { getScoreBgClass } from 'utils/scoreColor';

export interface SkillData {
  name: string;
  expectation: number;
  expectationLabel?: string;
  result: number;
  resultLabel: string;
  color: string;
}

export interface SkillsComparisonChartProps {
  expectationLabel?: string;
  resultLabel?: string;
  skills: SkillData[];
  maxValue?: number;
  showPercentages?: boolean;
  barHeight?: number;
  className?: string;
}

const SkillsComparisonChart: React.FC<SkillsComparisonChartProps> = ({
  expectationLabel = "Expectation",
  resultLabel = "Candidate's Result",
  skills,
  maxValue = 100,
  showPercentages = true,
  barHeight = 24,
  className = ""
}) => {

  return (
    <div className={`w-full sm:mt-11 mt-7 ${className}`}>
      <div className="grid sm:grid-cols-[1fr_200px_1fr] grid-cols-[1fr_100px_1fr] items-center mb-6 sm:px-4 gap-4 md:gap-0 sm:text-[17px] min-[450px]:text-sm text-xs">
        <h3 className="sm:pr-1 font-medium text-gray-800 text-right">
          {expectationLabel}
        </h3>
        <div className=""></div>
        <h3 className="text-left font-medium text-gray-800">
          {resultLabel}
        </h3>
      </div>

      <div className="grid sm:grid-cols-[1fr_170px_1fr] grid-cols-[1fr_130px_1fr] pt-2">
        <div className='space-y-[31px]'>
          {skills.map((skill, index) => (
            <div key={index} className="flex items-center gap-3">
              {showPercentages && (
                <span className="text-xs text-[#344054] text-right">
                  {skill.expectation}%
                </span>
              )}
              <div className="w-full h-2 relative overflow-visible">
                {skill.expectationLabel ? (
                  <div
                    className="right-0 absolute z-30 sm:-top-[19px] -top-[16px]"
                    style={{ width: `${skill.expectation}%` }}
                  >
                    <p className="text-[#344054] sm:font-medium sm:text-[10px] text-[8px] whitespace-nowrap mb-1 mr-auto w-fit">{skill.expectationLabel}</p>
                    <div className="bg-[#012169] rounded-l-full h-2" />
                  </div>
                ) : (
                  <div
                    className="bg-[#012169] rounded-l-full h-2 right-0 absolute z-30"
                    style={{ width: `${skill.expectation}%` }}
                  />
                )}
                <div className="bg-[#EAECF0] h-2 rounded-l-full" />
              </div>
            </div>
          ))}
        </div>
        <div className='border-l-2 border-r-2 border-[#D0D5DD] space-y-3 py-3 -mt-3.5'>
          {skills.map((skill, index) => (
            <div key={index} className="text-center mx-auto w-fit font-medium text-[#1D2939] sm:text-[13px] text-[11px]">
              {skill.name}
              {index !== skills.length - 1 && (
                <div className="h-[1px] w-[70px] bg-[#EAECF0] mx-auto mt-4" />
              )}
            </div>
          ))}
        </div>

        <div className='space-y-[31px]'>
          {skills.map((skill, index) => (
            <div key={index} className="flex flex-col md:flex-row items-center gap-2 md:gap-4 order-3">
              <div className="w-full flex items-center gap-4">
                <div className="w-full h-2 relative">
                  <div
                    className="left-0 absolute z-30 sm:-top-[19px] -top-[16px]"
                    style={{
                      width: `${skill.result}%`,
                    }}
                  >
                    <p className='text-[#344054 sm:font-medium sm:text-[10px] text-[8px] whitespace-nowrap mb-1 ml-auto w-fit'>{skill.resultLabel}</p>
                    <div className={`rounded-r-full h-2 ${getScoreBgClass(skill.result)}`} />
                    <div />
                  </div>
                  <div className='bg-[#EAECF0] h-2 rounded-r-full' />
                </div>
                {showPercentages && (
                  <span className="text-xs text-[#344054]">
                    {skill.result}%
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export { SkillsComparisonChart };